import { isEqual } from 'lodash';

function canViewCase(serviceCase) {
    return isEqual(serviceCase.state, 'managed') || isEqual(serviceCase.state, 'off_platform');
}

export default canViewCase;
